'use strict';

var React = require('react');
var componentsLoader = require('@keytrade/components-loader');
var componentsCard = require('@keytrade/components-card');
var componentsButton = require('@keytrade/components-button');
var componentsInputtext = require('@keytrade/components-inputtext');
var componentsParagraph = require('@keytrade/components-paragraph');
var componentsTitle = require('@keytrade/components-title');
var componentsIcon = require('@keytrade/components-icon');
var componentsList = require('@keytrade/components-list');
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
  cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
  cachedClearTimeout = clearTimeout;
}
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  }
  // if setTimeout wasn't available but was latter defined
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  }
  // if clearTimeout wasn't available but was latter defined
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }
  draining = false;
  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }
  if (queue.length) {
    drainQueue();
  }
}
function drainQueue() {
  if (draining) {
    return;
  }
  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;
  while (len) {
    currentQueue = queue;
    queue = [];
    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }
    queueIndex = -1;
    len = queue.length;
  }
  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}
function nextTick(fun) {
  var args = new Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }
  queue.push(new Item(fun, args));
  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
}
// v8 likes predictible objects
function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}
Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};
var title$3 = 'browser';
var platform = 'browser';
var browser = true;
var env = {};
var argv = [];
var version = ''; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config = {};
function noop() {}
var on = noop;
var addListener = noop;
var once = noop;
var off = noop;
var removeListener = noop;
var removeAllListeners = noop;
var emit = noop;
function binding(name) {
  throw new Error('process.binding is not supported');
}
function cwd() {
  return '/';
}
function chdir(dir) {
  throw new Error('process.chdir is not supported');
}
function umask() {
  return 0;
}

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function () {
  return new Date().getTime();
};

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp) {
  var clocktime = performanceNow.call(performance) * 1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor(clocktime % 1 * 1e9);
  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds < 0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds, nanoseconds];
}
var startTime = new Date();
function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}
var browser$1 = {
  nextTick: nextTick,
  title: title$3,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var reactIs$2 = {
  exports: {}
};
var reactIs_production = {};

/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production;
function requireReactIs_production() {
  if (hasRequiredReactIs_production) return reactIs_production;
  hasRequiredReactIs_production = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
    REACT_PORTAL_TYPE = Symbol.for("react.portal"),
    REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
    REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
    REACT_PROFILER_TYPE = Symbol.for("react.profiler");
  var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
    REACT_CONTEXT_TYPE = Symbol.for("react.context"),
    REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
    REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
    REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
    REACT_MEMO_TYPE = Symbol.for("react.memo"),
    REACT_LAZY_TYPE = Symbol.for("react.lazy"),
    REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"),
    REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
  function typeOf(object) {
    if ("object" === typeof object && null !== object) {
      var $$typeof = object.$$typeof;
      switch ($$typeof) {
        case REACT_ELEMENT_TYPE:
          switch (object = object.type, object) {
            case REACT_FRAGMENT_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_SUSPENSE_TYPE:
            case REACT_SUSPENSE_LIST_TYPE:
            case REACT_VIEW_TRANSITION_TYPE:
              return object;
            default:
              switch (object = object && object.$$typeof, object) {
                case REACT_CONTEXT_TYPE:
                case REACT_FORWARD_REF_TYPE:
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                  return object;
                case REACT_CONSUMER_TYPE:
                  return object;
                default:
                  return $$typeof;
              }
          }
        case REACT_PORTAL_TYPE:
          return $$typeof;
      }
    }
  }
  reactIs_production.ContextConsumer = REACT_CONSUMER_TYPE;
  reactIs_production.ContextProvider = REACT_CONTEXT_TYPE;
  reactIs_production.Element = REACT_ELEMENT_TYPE;
  reactIs_production.ForwardRef = REACT_FORWARD_REF_TYPE;
  reactIs_production.Fragment = REACT_FRAGMENT_TYPE;
  reactIs_production.Lazy = REACT_LAZY_TYPE;
  reactIs_production.Memo = REACT_MEMO_TYPE;
  reactIs_production.Portal = REACT_PORTAL_TYPE;
  reactIs_production.Profiler = REACT_PROFILER_TYPE;
  reactIs_production.StrictMode = REACT_STRICT_MODE_TYPE;
  reactIs_production.Suspense = REACT_SUSPENSE_TYPE;
  reactIs_production.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
  reactIs_production.isContextConsumer = function (object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
  };
  reactIs_production.isContextProvider = function (object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
  };
  reactIs_production.isElement = function (object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
  };
  reactIs_production.isForwardRef = function (object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
  };
  reactIs_production.isFragment = function (object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
  };
  reactIs_production.isLazy = function (object) {
    return typeOf(object) === REACT_LAZY_TYPE;
  };
  reactIs_production.isMemo = function (object) {
    return typeOf(object) === REACT_MEMO_TYPE;
  };
  reactIs_production.isPortal = function (object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
  };
  reactIs_production.isProfiler = function (object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
  };
  reactIs_production.isStrictMode = function (object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
  };
  reactIs_production.isSuspense = function (object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
  };
  reactIs_production.isSuspenseList = function (object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
  };
  reactIs_production.isValidElementType = function (type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
  };
  reactIs_production.typeOf = typeOf;
  return reactIs_production;
}
var reactIs_development$1 = {};
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  "production" !== browser$1.env.NODE_ENV && function () {
    function typeOf(object) {
      if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (object = object.type, object) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
              case REACT_VIEW_TRANSITION_TYPE:
                return object;
              default:
                switch (object = object && object.$$typeof, object) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object;
                  case REACT_CONSUMER_TYPE:
                    return object;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
      REACT_PORTAL_TYPE = Symbol.for("react.portal"),
      REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
      REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
      REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
      REACT_CONTEXT_TYPE = Symbol.for("react.context"),
      REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
      REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
      REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
      REACT_MEMO_TYPE = Symbol.for("react.memo"),
      REACT_LAZY_TYPE = Symbol.for("react.lazy"),
      REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"),
      REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    reactIs_development$1.ContextConsumer = REACT_CONSUMER_TYPE;
    reactIs_development$1.ContextProvider = REACT_CONTEXT_TYPE;
    reactIs_development$1.Element = REACT_ELEMENT_TYPE;
    reactIs_development$1.ForwardRef = REACT_FORWARD_REF_TYPE;
    reactIs_development$1.Fragment = REACT_FRAGMENT_TYPE;
    reactIs_development$1.Lazy = REACT_LAZY_TYPE;
    reactIs_development$1.Memo = REACT_MEMO_TYPE;
    reactIs_development$1.Portal = REACT_PORTAL_TYPE;
    reactIs_development$1.Profiler = REACT_PROFILER_TYPE;
    reactIs_development$1.StrictMode = REACT_STRICT_MODE_TYPE;
    reactIs_development$1.Suspense = REACT_SUSPENSE_TYPE;
    reactIs_development$1.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    reactIs_development$1.isContextConsumer = function (object) {
      return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    reactIs_development$1.isContextProvider = function (object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    reactIs_development$1.isElement = function (object) {
      return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    reactIs_development$1.isForwardRef = function (object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    reactIs_development$1.isFragment = function (object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    reactIs_development$1.isLazy = function (object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    };
    reactIs_development$1.isMemo = function (object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    };
    reactIs_development$1.isPortal = function (object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    };
    reactIs_development$1.isProfiler = function (object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    };
    reactIs_development$1.isStrictMode = function (object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    reactIs_development$1.isSuspense = function (object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    reactIs_development$1.isSuspenseList = function (object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    reactIs_development$1.isValidElementType = function (type) {
      return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
    };
    reactIs_development$1.typeOf = typeOf;
  }();
  return reactIs_development$1;
}
if (browser$1.env.NODE_ENV === 'production') {
  reactIs$2.exports = requireReactIs_production();
} else {
  reactIs$2.exports = requireReactIs_development$1();
}
var reactIsExports$1 = reactIs$2.exports;
function stylis_min(W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f += e.charAt(l);
          }
          g = 59;
        }
        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;
            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;
                case 125:
                  k--;
                  break;
                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }
                          }
                        }
                        l = u;
                      }
                  }
                  break;
                case 91:
                  g++;
                case 40:
                  g++;
                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {}
              }
              if (0 === k) break;
              l++;
            }
            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);
                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;
                  default:
                    r = O;
                }
                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);
                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;
                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;
                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;
              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }
            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;
          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;
              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }
              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }
      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;
        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }
        default:
          z++;
          y = e.charAt(l);
          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;
                default:
                  32 !== g && (y = ' ');
              }
              break;
            case 0:
              y = '\\0';
              break;
            case 12:
              y = '\\f';
              break;
            case 11:
              y = '\\v';
              break;
            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;
            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                case 8:
                  111 === K && (E = K);
              }
              break;
            case 58:
              0 === n + b + m && (u = l);
              break;
            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;
            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;
            case 91:
              0 === n + b + v && m++;
              break;
            case 93:
              0 === n + b + v && m--;
              break;
            case 41:
              0 === n + b + m && v--;
              break;
            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;
                  default:
                    q = 1;
                }
                v++;
              }
              break;
            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;
                    case 220:
                      t = l, b = 42;
                  }
                  break;
                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }
          0 === b && (f += y);
      }
      K = x;
      x = g;
      l++;
    }
    t = p.length;
    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';
      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);
        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;
          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }
        E = 0;
      }
    }
    return G + p + F;
  }
  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
      m = d.length;
    switch (m) {
      case 0:
      case 1:
        var b = 0;
        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }
        break;
      default:
        var v = b = 0;
        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }
    }
    return c;
  }
  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));
    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());
      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());
      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }
    return d + c;
  }
  function P(d, c, e, h) {
    var a = d + ';',
      m = 2 * c + 3 * e + 4 * h;
    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }
    if (0 === w || 2 === w && !L(a, 1)) return a;
    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
      case 1009:
        if (100 !== a.charCodeAt(4)) break;
      case 969:
      case 942:
        return '-webkit-' + a + a;
      case 978:
        return '-webkit-' + a + '-moz-' + a + a;
      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;
      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;
      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;
      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;
        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;
          case 232:
            b = a.replace(G, 'tb-rl');
            break;
          case 220:
            b = a.replace(G, 'lr');
            break;
          default:
            return a;
        }
        return '-webkit-' + a + '-ms-' + b + a;
      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;
      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;
          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;
          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }
        return a + ';';
      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;
      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;
      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }
    return a;
  }
  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
      h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }
  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }
  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          x = w;
      }
    }
    if (x !== c) return x;
  }
  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;
      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }
    return T;
  }
  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }
  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];
    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }
    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }
  var ca = /^\0+/g,
    N = /[\0\r\f]/g,
    aa = /: */g,
    ka = /zoo|gra/,
    ma = /([,: ])(transform)/g,
    ia = /,\r+?/g,
    F = /([\t\r\n ])*\f?&/g,
    fa = /@(k\w+)\s*(\S*)\s*/,
    Q = /::(place)/g,
    ha = /:(read-only)/g,
    G = /[svh]\w+-[tblr]{2}/,
    da = /\(\s*(.*)\s*\)/g,
    oa = /([\s\S]*?);/g,
    ba = /-self|flex-/g,
    na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    la = /stretch|:\s*\w+\-(?:conte|avail)/,
    ja = /([^-])(image-set\()/,
    z = 1,
    D = 1,
    E = 0,
    w = 1,
    O = [],
    S = [],
    A = 0,
    R = null,
    Y = 0,
    V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);
var reactIs$1 = {
  exports: {}
};
var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (browser$1.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
if (browser$1.env.NODE_ENV === 'production') {
  reactIs$1.exports = requireReactIs_production_min();
} else {
  reactIs$1.exports = requireReactIs_development();
}
var reactIsExports = reactIs$1.exports;
var reactIs = reactIsExports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];
      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
var m = /*@__PURE__*/getDefaultExportFromCjs(hoistNonReactStatics_cjs);
function v() {
  return (v = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var y = function (e, t) {
    for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1) n.push(t[r], e[r + 1]);
    return n;
  },
  g = function (t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !reactIsExports$1.typeOf(t);
  },
  S = Object.freeze([]),
  w = Object.freeze({});
function E(e) {
  return "function" == typeof e;
}
function b(e) {
  return "production" !== browser$1.env.NODE_ENV && "string" == typeof e && e || e.displayName || e.name || "Component";
}
function N(e) {
  return e && "string" == typeof e.styledComponentId;
}
var _ = "undefined" != typeof browser$1 && (browser$1.env.REACT_APP_SC_ATTR || browser$1.env.SC_ATTR) || "data-styled",
  A = "undefined" != typeof window && "HTMLElement" in window,
  I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof browser$1 && void 0 !== browser$1.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== browser$1.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== browser$1.env.REACT_APP_SC_DISABLE_SPEEDY && browser$1.env.REACT_APP_SC_DISABLE_SPEEDY : "undefined" != typeof browser$1 && void 0 !== browser$1.env.SC_DISABLE_SPEEDY && "" !== browser$1.env.SC_DISABLE_SPEEDY ? "false" !== browser$1.env.SC_DISABLE_SPEEDY && browser$1.env.SC_DISABLE_SPEEDY : "production" !== browser$1.env.NODE_ENV),
  P = {},
  O = "production" !== browser$1.env.NODE_ENV ? {
    1: "Cannot create styled-component for component: %s.\n\n",
    2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
    9: "Missing document `<head>`\n\n",
    10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    14: 'ThemeProvider: "theme" prop is required.\n\n',
    15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
  } : {};
function R() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1) t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
  return t.forEach(function (t) {
    e = e.replace(/%[a-z]/, t);
  }), e;
}
function D(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  throw "production" === browser$1.env.NODE_ENV ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : "")) : new Error(R.apply(void 0, [O[e]].concat(n)).trim());
}
var j = function () {
    function e(e) {
      this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function (e) {
      for (var t = 0, n = 0; n < e; n++) t += this.groupSizes[n];
      return t;
    }, t.insertRules = function (e, t) {
      if (e >= this.groupSizes.length) {
        for (var n = this.groupSizes, r = n.length, o = r; e >= o;) (o <<= 1) < 0 && D(16, "" + e);
        this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
        for (var i = r; i < o; i++) this.groupSizes[i] = 0;
      }
      for (var s = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++) this.tag.insertRule(s, t[a]) && (this.groupSizes[e]++, s++);
    }, t.clearGroup = function (e) {
      if (e < this.length) {
        var t = this.groupSizes[e],
          n = this.indexOfGroup(e),
          r = n + t;
        this.groupSizes[e] = 0;
        for (var o = n; o < r; o++) this.tag.deleteRule(n);
      }
    }, t.getGroup = function (e) {
      var t = "";
      if (e >= this.length || 0 === this.groupSizes[e]) return t;
      for (var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, i = r; i < o; i++) t += this.tag.getRule(i) + "/*!sc*/\n";
      return t;
    }, e;
  }(),
  T = new Map(),
  x = new Map(),
  k = 1,
  V = function (e) {
    if (T.has(e)) return T.get(e);
    for (; x.has(k);) k++;
    var t = k++;
    return "production" !== browser$1.env.NODE_ENV && ((0 | t) < 0 || t > 1 << 30) && D(16, "" + t), T.set(e, t), x.set(t, e), t;
  },
  M = function (e) {
    return x.get(e);
  },
  B = function (e, t) {
    T.set(e, t), x.set(t, e);
  },
  z = "style[" + _ + '][data-styled-version="5.3.0"]',
  L = new RegExp("^" + _ + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
  G = function (e, t, n) {
    for (var r, o = n.split(","), i = 0, s = o.length; i < s; i++) (r = o[i]) && e.registerName(t, r);
  },
  F = function (e, t) {
    for (var n = t.innerHTML.split("/*!sc*/\n"), r = [], o = 0, i = n.length; o < i; o++) {
      var s = n[o].trim();
      if (s) {
        var a = s.match(L);
        if (a) {
          var c = 0 | parseInt(a[1], 10),
            u = a[2];
          0 !== c && (B(u, c), G(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
        } else r.push(s);
      }
    }
  },
  Y = function () {
    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
  },
  q = function (e) {
    var t = document.head,
      n = e || t,
      r = document.createElement("style"),
      o = function (e) {
        for (var t = e.childNodes, n = t.length; n >= 0; n--) {
          var r = t[n];
          if (r && 1 === r.nodeType && r.hasAttribute(_)) return r;
        }
      }(n),
      i = void 0 !== o ? o.nextSibling : null;
    r.setAttribute(_, "active"), r.setAttribute("data-styled-version", "5.3.0");
    var s = Y();
    return s && r.setAttribute("nonce", s), n.insertBefore(r, i), r;
  },
  H = function () {
    function e(e) {
      var t = this.element = q(e);
      t.appendChild(document.createTextNode("")), this.sheet = function (e) {
        if (e.sheet) return e.sheet;
        for (var t = document.styleSheets, n = 0, r = t.length; n < r; n++) {
          var o = t[n];
          if (o.ownerNode === e) return o;
        }
        D(17);
      }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      try {
        return this.sheet.insertRule(t, e), this.length++, !0;
      } catch (e) {
        return !1;
      }
    }, t.deleteRule = function (e) {
      this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function (e) {
      var t = this.sheet.cssRules[e];
      return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
  }(),
  $ = function () {
    function e(e) {
      var t = this.element = q(e);
      this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      if (e <= this.length && e >= 0) {
        var n = document.createTextNode(t),
          r = this.nodes[e];
        return this.element.insertBefore(n, r || null), this.length++, !0;
      }
      return !1;
    }, t.deleteRule = function (e) {
      this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function (e) {
      return e < this.length ? this.nodes[e].textContent : "";
    }, e;
  }(),
  W = function () {
    function e(e) {
      this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function (e) {
      this.rules.splice(e, 1), this.length--;
    }, t.getRule = function (e) {
      return e < this.length ? this.rules[e] : "";
    }, e;
  }(),
  U = A,
  J = {
    isServer: !A,
    useCSSOMInjection: !I
  },
  Z = function () {
    function e(e, t, n) {
      void 0 === e && (e = w), void 0 === t && (t = {}), this.options = v({}, J, {}, e), this.gs = t, this.names = new Map(n), !this.options.isServer && A && U && (U = !1, function (e) {
        for (var t = document.querySelectorAll(z), n = 0, r = t.length; n < r; n++) {
          var o = t[n];
          o && "active" !== o.getAttribute(_) && (F(e, o), o.parentNode && o.parentNode.removeChild(o));
        }
      }(this));
    }
    e.registerId = function (e) {
      return V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function (t, n) {
      return void 0 === n && (n = !0), new e(v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function (e) {
      return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function () {
      return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new W(o) : r ? new H(o) : new $(o), new j(e)));
      var e, t, n, r, o;
    }, t.hasNameForId = function (e, t) {
      return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function (e, t) {
      if (V(e), this.names.has(e)) this.names.get(e).add(t);else {
        var n = new Set();
        n.add(t), this.names.set(e, n);
      }
    }, t.insertRules = function (e, t, n) {
      this.registerName(e, t), this.getTag().insertRules(V(e), n);
    }, t.clearNames = function (e) {
      this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function (e) {
      this.getTag().clearGroup(V(e)), this.clearNames(e);
    }, t.clearTag = function () {
      this.tag = void 0;
    }, t.toString = function () {
      return function (e) {
        for (var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++) {
          var i = M(o);
          if (void 0 !== i) {
            var s = e.names.get(i),
              a = t.getGroup(o);
            if (void 0 !== s && 0 !== a.length) {
              var c = _ + ".g" + o + '[id="' + i + '"]',
                u = "";
              void 0 !== s && s.forEach(function (e) {
                e.length > 0 && (u += e + ",");
              }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
            }
          }
        }
        return r;
      }(this);
    }, e;
  }(),
  X = /(a)(d)/gi,
  K = function (e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
  };
function Q(e) {
  var t,
    n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = K(t % 52) + n;
  return (K(t % 52) + n).replace(X, "$1-$2");
}
var ee = function (e, t) {
    for (var n = t.length; n;) e = 33 * e ^ t.charCodeAt(--n);
    return e;
  },
  te = function (e) {
    return ee(5381, e);
  };
function ne(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (E(n) && !N(n)) return !1;
  }
  return !0;
}
var re = te("5.3.0"),
  oe = function () {
    function e(e, t, n) {
      this.rules = e, this.staticRulesId = "", this.isStatic = "production" === browser$1.env.NODE_ENV && (void 0 === n || n.isStatic) && ne(e), this.componentId = t, this.baseHash = ee(re, t), this.baseStyle = n, Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function (e, t, n) {
      var r = this.componentId,
        o = [];
      if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
        if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);else {
          var i = Ne(this.rules, e, t, n).join(""),
            s = Q(ee(this.baseHash, i.length) >>> 0);
          if (!t.hasNameForId(r, s)) {
            var a = n(i, "." + s, void 0, r);
            t.insertRules(r, s, a);
          }
          o.push(s), this.staticRulesId = s;
        }
      } else {
        for (var c = this.rules.length, u = ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++) {
          var h = this.rules[d];
          if ("string" == typeof h) l += h, "production" !== browser$1.env.NODE_ENV && (u = ee(u, h + d));else if (h) {
            var p = Ne(h, e, t, n),
              f = Array.isArray(p) ? p.join("") : p;
            u = ee(u, f + d), l += f;
          }
        }
        if (l) {
          var m = Q(u >>> 0);
          if (!t.hasNameForId(r, m)) {
            var v = n(l, "." + m, void 0, r);
            t.insertRules(r, m, v);
          }
          o.push(m);
        }
      }
      return o.join(" ");
    }, e;
  }(),
  ie = /^\s*\/\/.*$/gm,
  se = [":", "[", ".", "#"];
function ae(e) {
  var t,
    n,
    r,
    o,
    i = void 0 === e ? w : e,
    s = i.options,
    a = void 0 === s ? w : s,
    c = i.plugins,
    u = void 0 === c ? S : c,
    l = new stylis_min(a),
    d = [],
    p = function (e) {
      function t(t) {
        if (t) try {
          e(t + "}");
        } catch (e) {}
      }
      return function (n, r, o, i, s, a, c, u, l, d) {
        switch (n) {
          case 1:
            if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
            break;
          case 2:
            if (0 === u) return r + "/*|*/";
            break;
          case 3:
            switch (u) {
              case 102:
              case 112:
                return e(o[0] + r), "";
              default:
                return r + (0 === d ? "/*|*/" : "");
            }
          case -2:
            r.split("/*|*/}").forEach(t);
        }
      };
    }(function (e) {
      d.push(e);
    }),
    f = function (e, r, i) {
      return 0 === r && -1 !== se.indexOf(i[n.length]) || i.match(o) ? e : "." + t;
    };
  function m(e, i, s, a) {
    void 0 === a && (a = "&");
    var c = e.replace(ie, ""),
      u = i && s ? s + " " + i + " { " + c + " }" : c;
    return t = a, n = i, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(s || !i ? "" : i, u);
  }
  return l.use([].concat(u, [function (e, t, o) {
    2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
  }, p, function (e) {
    if (-2 === e) {
      var t = d;
      return d = [], t;
    }
  }])), m.hash = u.length ? u.reduce(function (e, t) {
    return t.name || D(15), ee(e, t.name);
  }, 5381).toString() : "", m;
}
var ce = /*#__PURE__*/React.createContext();
ce.Consumer;
var le = /*#__PURE__*/React.createContext(),
  de = (le.Consumer, new Z()),
  he = ae();
function pe() {
  return React.useContext(ce) || de;
}
function fe() {
  return React.useContext(le) || he;
}
var ve = function () {
    function e(e, t) {
      var n = this;
      this.inject = function (e, t) {
        void 0 === t && (t = he);
        var r = n.name + t.hash;
        e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
      }, this.toString = function () {
        return D(12, String(n.name));
      }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function (e) {
      return void 0 === e && (e = he), this.name + e.hash;
    }, e;
  }(),
  ye = /([A-Z])/,
  ge = /([A-Z])/g,
  Se = /^ms-/,
  we = function (e) {
    return "-" + e.toLowerCase();
  };
function Ee(e) {
  return ye.test(e) ? e.replace(ge, we).replace(Se, "-ms-") : e;
}
var be = function (e) {
  return null == e || !1 === e || "" === e;
};
function Ne(e, n, r, o) {
  if (Array.isArray(e)) {
    for (var i, s = [], a = 0, c = e.length; a < c; a += 1) "" !== (i = Ne(e[a], n, r, o)) && (Array.isArray(i) ? s.push.apply(s, i) : s.push(i));
    return s;
  }
  if (be(e)) return "";
  if (N(e)) return "." + e.styledComponentId;
  if (E(e)) {
    if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
    var u = e(n);
    return "production" !== browser$1.env.NODE_ENV && reactIsExports$1.isElement(u) && console.warn(b(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Ne(u, n, r, o);
  }
  var l;
  return e instanceof ve ? r ? (e.inject(r, o), e.getName(o)) : e : g(e) ? function e(t, n) {
    var r,
      o,
      i = [];
    for (var s in t) t.hasOwnProperty(s) && !be(t[s]) && (g(t[s]) ? i.push.apply(i, e(t[s], s)) : E(t[s]) ? i.push(Ee(s) + ":", t[s], ";") : i.push(Ee(s) + ": " + (r = s, null == (o = t[s]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in unitlessKeys ? String(o).trim() : o + "px") + ";"));
    return n ? [n + " {"].concat(i, ["}"]) : i;
  }(e) : e.toString();
}
function _e(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return E(e) || g(e) ? Ne(y(S, [e].concat(n))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : Ne(y(e, n));
}
var Ce = /invalid hook call/i,
  Ae = new Set(),
  Ie = function (e, t) {
    if ("production" !== browser$1.env.NODE_ENV) {
      var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.";
      try {
        React.useRef(), Ae.has(n) || (console.warn(n), Ae.add(n));
      } catch (e) {
        Ce.test(e.message) && Ae.delete(n);
      }
    }
  },
  Pe = function (e, t, n) {
    return void 0 === n && (n = w), e.theme !== n.theme && e.theme || t || n.theme;
  },
  Oe = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
  Re = /(^-|-$)/g;
function De(e) {
  return e.replace(Oe, "-").replace(Re, "");
}
var je = function (e) {
  return Q(te(e) >>> 0);
};
function Te(e) {
  return "string" == typeof e && ("production" === browser$1.env.NODE_ENV || e.charAt(0) === e.charAt(0).toLowerCase());
}
var xe = function (e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
  },
  ke = function (e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
  };
function Ve(e, t, n) {
  var r = e[n];
  xe(t) && xe(r) ? Me(r, t) : e[n] = t;
}
function Me(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  for (var o = 0, i = n; o < i.length; o++) {
    var s = i[o];
    if (xe(s)) for (var a in s) ke(a) && Ve(e, s[a], a);
  }
  return e;
}
var Be = /*#__PURE__*/React.createContext();
Be.Consumer;
var Ge = {};
function Fe(e, t, n) {
  var o = N(e),
    s = !Te(e),
    a = t.attrs,
    c = void 0 === a ? S : a,
    d = t.componentId,
    h = void 0 === d ? function (e, t) {
      var n = "string" != typeof e ? "sc" : De(e);
      Ge[n] = (Ge[n] || 0) + 1;
      var r = n + "-" + je("5.3.0" + n + Ge[n]);
      return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d,
    p = t.displayName,
    y = void 0 === p ? function (e) {
      return Te(e) ? "styled." + e : "Styled(" + b(e) + ")";
    }(e) : p,
    g = t.displayName && t.componentId ? De(t.displayName) + "-" + t.componentId : t.componentId || h,
    _ = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c,
    C = t.shouldForwardProp;
  o && e.shouldForwardProp && (C = t.shouldForwardProp ? function (n, r, o) {
    return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
  } : e.shouldForwardProp);
  var A,
    I = new oe(n, g, o ? e.componentStyle : void 0),
    P = I.isStatic && 0 === c.length,
    O = function (e, t) {
      return function (e, t, n, r) {
        var o = e.attrs,
          s = e.componentStyle,
          a = e.defaultProps,
          c = e.foldedComponentIds,
          d = e.shouldForwardProp,
          h = e.styledComponentId,
          p = e.target;
        "production" !== browser$1.env.NODE_ENV && React.useDebugValue(h);
        var m = function (e, t, n) {
            void 0 === e && (e = w);
            var r = v({}, t, {
                theme: e
              }),
              o = {};
            return n.forEach(function (e) {
              var t,
                n,
                i,
                s = e;
              for (t in E(s) && (s = s(r)), s) r[t] = o[t] = "className" === t ? (n = o[t], i = s[t], n && i ? n + " " + i : n || i) : s[t];
            }), [r, o];
          }(Pe(t, React.useContext(Be), a) || w, t, o),
          y = m[0],
          g = m[1],
          S = function (e, t, n, r) {
            var o = pe(),
              i = fe(),
              s = t ? e.generateAndInjectStyles(w, o, i) : e.generateAndInjectStyles(n, o, i);
            return "production" !== browser$1.env.NODE_ENV && React.useDebugValue(s), "production" !== browser$1.env.NODE_ENV && !t && r && r(s), s;
          }(s, r, y, "production" !== browser$1.env.NODE_ENV ? e.warnTooManyClasses : void 0),
          b = n,
          N = g.$as || t.$as || g.as || t.as || p,
          _ = Te(N),
          C = g !== t ? v({}, t, {}, g) : t,
          A = {};
        for (var I in C) "$" !== I[0] && "as" !== I && ("forwardedAs" === I ? A.as = C[I] : (d ? d(I, index, N) : !_ || index(I)) && (A[I] = C[I]));
        return t.style && g.style !== t.style && (A.style = v({}, t.style, {}, g.style)), A.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), A.ref = b, /*#__PURE__*/React.createElement(N, A);
      }(A, e, t, P);
    };
  return O.displayName = y, (A = /*#__PURE__*/React.forwardRef(O)).attrs = _, A.componentStyle = I, A.displayName = y, A.shouldForwardProp = C, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : S, A.styledComponentId = g, A.target = o ? e.target : e, A.withComponent = function (e) {
    var r = t.componentId,
      o = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          o = {},
          i = Object.keys(e);
        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
        return o;
      }(t, ["componentId"]),
      i = r && r + "-" + (Te(e) ? e : De(b(e)));
    return Fe(e, v({}, o, {
      attrs: _,
      componentId: i
    }), n);
  }, Object.defineProperty(A, "defaultProps", {
    get: function () {
      return this._foldedDefaultProps;
    },
    set: function (t) {
      this._foldedDefaultProps = o ? Me({}, e.defaultProps, t) : t;
    }
  }), "production" !== browser$1.env.NODE_ENV && (Ie(y, g), A.warnTooManyClasses = function (e, t) {
    var n = {},
      r = !1;
    return function (o) {
      if (!r && (n[o] = !0, Object.keys(n).length >= 200)) {
        var i = t ? ' with the id of "' + t + '"' : "";
        console.warn("Over 200 classes were generated for component " + e + i + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r = !0, n = {};
      }
    };
  }(y, g)), A.toString = function () {
    return "." + A.styledComponentId;
  }, s && m(A, e, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), A;
}
var Ye = function (e) {
  return function e(t, r, o) {
    if (void 0 === o && (o = w), !reactIsExports$1.isValidElementType(r)) return D(1, String(r));
    var i = function () {
      return t(r, o, _e.apply(void 0, arguments));
    };
    return i.withConfig = function (n) {
      return e(t, r, v({}, o, {}, n));
    }, i.attrs = function (n) {
      return e(t, r, v({}, o, {
        attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
      }));
    }, i;
  }(Fe, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function (e) {
  Ye[e] = Ye(e);
});
var qe = function () {
  function e(e, t) {
    this.rules = e, this.componentId = t, this.isStatic = ne(e), Z.registerId(this.componentId + 1);
  }
  var t = e.prototype;
  return t.createStyles = function (e, t, n, r) {
    var o = r(Ne(this.rules, t, n, r).join(""), ""),
      i = this.componentId + e;
    n.insertRules(i, i, o);
  }, t.removeStyles = function (e, t) {
    t.clearRules(this.componentId + e);
  }, t.renderStyles = function (e, t, n, r) {
    e > 2 && Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
  }, e;
}();
function He(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) n[o - 1] = arguments[o];
  var s = _e.apply(void 0, [e].concat(n)),
    a = "sc-global-" + je(JSON.stringify(s)),
    u = new qe(s, a);
  function l(e) {
    var t = pe(),
      n = fe(),
      o = React.useContext(Be),
      u = React.useRef(t.allocateGSInstance(a)).current;
    return "production" !== browser$1.env.NODE_ENV && React.Children.count(e.children) && console.warn("The global style component " + a + " was given child JSX. createGlobalStyle does not render children."), "production" !== browser$1.env.NODE_ENV && s.some(function (e) {
      return "string" == typeof e && -1 !== e.indexOf("@import");
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), d(u, e, t, o, n), null;
  }
  function d(e, t, n, r, o) {
    if (u.isStatic) u.renderStyles(e, P, n, o);else {
      var i = v({}, t, {
        theme: Pe(t, r, l.defaultProps)
      });
      u.renderStyles(e, i, n, o);
    }
  }
  return "production" !== browser$1.env.NODE_ENV && Ie(a), /*#__PURE__*/React.memo(l);
}
"production" !== browser$1.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "production" !== browser$1.env.NODE_ENV && browser$1.env.NODE_ENV;
var styled = Ye;
const createStoreImpl = createState => {
  let state;
  const listeners = /* @__PURE__ */new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
      listeners.forEach(listener => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if ((undefined && undefined.MODE) !== "production") {
      console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
    }
    listeners.clear();
  };
  const api = {
    setState,
    getState,
    subscribe,
    destroy
  };
  state = createState(setState, getState, api);
  return api;
};
const createStore = createState => createState ? createStoreImpl(createState) : createStoreImpl;
var withSelector = {
  exports: {}
};
var withSelector_production_min = {};
var shim = {
  exports: {}
};
var useSyncExternalStoreShim_production_min = {};

/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
  if (hasRequiredUseSyncExternalStoreShim_production_min) return useSyncExternalStoreShim_production_min;
  hasRequiredUseSyncExternalStoreShim_production_min = 1;
  var e = React;
  function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var k = "function" === typeof Object.is ? Object.is : h,
    l = e.useState,
    m = e.useEffect,
    n = e.useLayoutEffect,
    p = e.useDebugValue;
  function q(a, b) {
    var d = b(),
      f = l({
        inst: {
          value: d,
          getSnapshot: b
        }
      }),
      c = f[0].inst,
      g = f[1];
    n(function () {
      c.value = d;
      c.getSnapshot = b;
      r(c) && g({
        inst: c
      });
    }, [a, d, b]);
    m(function () {
      r(c) && g({
        inst: c
      });
      return a(function () {
        r(c) && g({
          inst: c
        });
      });
    }, [a]);
    p(d);
    return d;
  }
  function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
      var d = b();
      return !k(a, d);
    } catch (f) {
      return !0;
    }
  }
  function t(a, b) {
    return b();
  }
  var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
  useSyncExternalStoreShim_production_min.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;
  return useSyncExternalStoreShim_production_min;
}
var useSyncExternalStoreShim_development = {};
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  if (hasRequiredUseSyncExternalStoreShim_development) return useSyncExternalStoreShim_development;
  hasRequiredUseSyncExternalStoreShim_development = 1;
  if (browser$1.env.NODE_ENV !== "production") {
    (function () {
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React$1 = React;
      var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning('error', format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          } // eslint-disable-next-line react-internal/safe-string-coercion

          var argsWithFormat = args.map(function (item) {
            return String(item);
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
      }
      var objectIs = typeof Object.is === 'function' ? Object.is : is;

      // dispatch for CommonJS interop named imports.

      var useState = React$1.useState,
        useEffect = React$1.useEffect,
        useLayoutEffect = React$1.useLayoutEffect,
        useDebugValue = React$1.useDebugValue;
      var didWarnOld18Alpha = false;
      var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
      // because of a very particular set of implementation details and assumptions
      // -- change any one of them and it will break. The most important assumption
      // is that updates are always synchronous, because concurrent rendering is
      // only available in versions of React that also have a built-in
      // useSyncExternalStore API. And we only use this shim when the built-in API
      // does not exist.
      //
      // Do not assume that the clever hacks used by this hook also work in general.
      // The point of this shim is to replace the need for hacks by other libraries.

      function useSyncExternalStore(subscribe, getSnapshot,
      // Note: The shim does not use getServerSnapshot, because pre-18 versions of
      // React do not expose a way to check if we're hydrating. So users of the shim
      // will need to track that themselves and return the correct value
      // from `getSnapshot`.
      getServerSnapshot) {
        {
          if (!didWarnOld18Alpha) {
            if (React$1.startTransition !== undefined) {
              didWarnOld18Alpha = true;
              error('You are using an outdated, pre-release alpha of React 18 that ' + 'does not support useSyncExternalStore. The ' + 'use-sync-external-store shim will not work correctly. Upgrade ' + 'to a newer pre-release.');
            }
          }
        } // Read the current snapshot from the store on every render. Again, this
        // breaks the rules of React, and only works here because of specific
        // implementation details, most importantly that updates are
        // always synchronous.

        var value = getSnapshot();
        {
          if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs(value, cachedValue)) {
              error('The result of getSnapshot should be cached to avoid an infinite loop');
              didWarnUncachedGetSnapshot = true;
            }
          }
        } // Because updates are synchronous, we don't queue them. Instead we force a
        // re-render whenever the subscribed state changes by updating an some
        // arbitrary useState hook. Then, during render, we call getSnapshot to read
        // the current value.
        //
        // Because we don't actually use the state returned by the useState hook, we
        // can save a bit of memory by storing other stuff in that slot.
        //
        // To implement the early bailout, we need to track some things on a mutable
        // object. Usually, we would put that in a useRef hook, but we can stash it in
        // our useState hook instead.
        //
        // To force a re-render, we call forceUpdate({inst}). That works because the
        // new object always fails an equality check.

        var _useState = useState({
            inst: {
              value: value,
              getSnapshot: getSnapshot
            }
          }),
          inst = _useState[0].inst,
          forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
        // in the layout phase so we can access it during the tearing check that
        // happens on subscribe.

        useLayoutEffect(function () {
          inst.value = value;
          inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
          // commit phase if there was an interleaved mutation. In concurrent mode
          // this can happen all the time, but even in synchronous mode, an earlier
          // effect may have mutated the store.

          if (checkIfSnapshotChanged(inst)) {
            // Force a re-render.
            forceUpdate({
              inst: inst
            });
          }
        }, [subscribe, value, getSnapshot]);
        useEffect(function () {
          // Check for changes right before subscribing. Subsequent changes will be
          // detected in the subscription handler.
          if (checkIfSnapshotChanged(inst)) {
            // Force a re-render.
            forceUpdate({
              inst: inst
            });
          }
          var handleStoreChange = function () {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) {
              // Force a re-render.
              forceUpdate({
                inst: inst
              });
            }
          }; // Subscribe to the store and return a clean-up function.

          return subscribe(handleStoreChange);
        }, [subscribe]);
        useDebugValue(value);
        return value;
      }
      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
          var nextValue = latestGetSnapshot();
          return !objectIs(prevValue, nextValue);
        } catch (error) {
          return true;
        }
      }
      function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        // Note: The shim does not use getServerSnapshot, because pre-18 versions of
        // React do not expose a way to check if we're hydrating. So users of the shim
        // will need to track that themselves and return the correct value
        // from `getSnapshot`.
        return getSnapshot();
      }
      var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
      var isServerEnvironment = !canUseDOM;
      var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
      var useSyncExternalStore$2 = React$1.useSyncExternalStore !== undefined ? React$1.useSyncExternalStore : shim;
      useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim.exports;
  hasRequiredShim = 1;
  if (browser$1.env.NODE_ENV === 'production') {
    shim.exports = requireUseSyncExternalStoreShim_production_min();
  } else {
    shim.exports = requireUseSyncExternalStoreShim_development();
  }
  return shim.exports;
}

/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production_min;
function requireWithSelector_production_min() {
  if (hasRequiredWithSelector_production_min) return withSelector_production_min;
  hasRequiredWithSelector_production_min = 1;
  var h = React,
    n = requireShim();
  function p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var q = "function" === typeof Object.is ? Object.is : p,
    r = n.useSyncExternalStore,
    t = h.useRef,
    u = h.useEffect,
    v = h.useMemo,
    w = h.useDebugValue;
  withSelector_production_min.useSyncExternalStoreWithSelector = function (a, b, e, l, g) {
    var c = t(null);
    if (null === c.current) {
      var f = {
        hasValue: !1,
        value: null
      };
      c.current = f;
    } else f = c.current;
    c = v(function () {
      function a(a) {
        if (!c) {
          c = !0;
          d = a;
          a = l(a);
          if (void 0 !== g && f.hasValue) {
            var b = f.value;
            if (g(b, a)) return k = b;
          }
          return k = a;
        }
        b = k;
        if (q(d, a)) return b;
        var e = l(a);
        if (void 0 !== g && g(b, e)) return b;
        d = a;
        return k = e;
      }
      var c = !1,
        d,
        k,
        m = void 0 === e ? null : e;
      return [function () {
        return a(b());
      }, null === m ? void 0 : function () {
        return a(m());
      }];
    }, [b, e, l, g]);
    var d = r(a, c[0], c[1]);
    u(function () {
      f.hasValue = !0;
      f.value = d;
    }, [d]);
    w(d);
    return d;
  };
  return withSelector_production_min;
}
var withSelector_development = {};
var hasRequiredWithSelector_development;
function requireWithSelector_development() {
  if (hasRequiredWithSelector_development) return withSelector_development;
  hasRequiredWithSelector_development = 1;
  if (browser$1.env.NODE_ENV !== "production") {
    (function () {
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React$1 = React;
      var shim = requireShim();

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
      }
      var objectIs = typeof Object.is === 'function' ? Object.is : is;
      var useSyncExternalStore = shim.useSyncExternalStore;

      // for CommonJS interop.

      var useRef = React$1.useRef,
        useEffect = React$1.useEffect,
        useMemo = React$1.useMemo,
        useDebugValue = React$1.useDebugValue; // Same as useSyncExternalStore, but supports selector and isEqual arguments.

      function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        // Use this to track the rendered snapshot.
        var instRef = useRef(null);
        var inst;
        if (instRef.current === null) {
          inst = {
            hasValue: false,
            value: null
          };
          instRef.current = inst;
        } else {
          inst = instRef.current;
        }
        var _useMemo = useMemo(function () {
            // Track the memoized state using closure variables that are local to this
            // memoized instance of a getSnapshot function. Intentionally not using a
            // useRef hook, because that state would be shared across all concurrent
            // copies of the hook/component.
            var hasMemo = false;
            var memoizedSnapshot;
            var memoizedSelection;
            var memoizedSelector = function (nextSnapshot) {
              if (!hasMemo) {
                // The first time the hook is called, there is no memoized result.
                hasMemo = true;
                memoizedSnapshot = nextSnapshot;
                var _nextSelection = selector(nextSnapshot);
                if (isEqual !== undefined) {
                  // Even if the selector has changed, the currently rendered selection
                  // may be equal to the new selection. We should attempt to reuse the
                  // current value if possible, to preserve downstream memoizations.
                  if (inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, _nextSelection)) {
                      memoizedSelection = currentSelection;
                      return currentSelection;
                    }
                  }
                }
                memoizedSelection = _nextSelection;
                return _nextSelection;
              } // We may be able to reuse the previous invocation's result.

              // We may be able to reuse the previous invocation's result.
              var prevSnapshot = memoizedSnapshot;
              var prevSelection = memoizedSelection;
              if (objectIs(prevSnapshot, nextSnapshot)) {
                // The snapshot is the same as last time. Reuse the previous selection.
                return prevSelection;
              } // The snapshot has changed, so we need to compute a new selection.

              // The snapshot has changed, so we need to compute a new selection.
              var nextSelection = selector(nextSnapshot); // If a custom isEqual function is provided, use that to check if the data
              // has changed. If it hasn't, return the previous selection. That signals
              // to React that the selections are conceptually equal, and we can bail
              // out of rendering.

              // If a custom isEqual function is provided, use that to check if the data
              // has changed. If it hasn't, return the previous selection. That signals
              // to React that the selections are conceptually equal, and we can bail
              // out of rendering.
              if (isEqual !== undefined && isEqual(prevSelection, nextSelection)) {
                return prevSelection;
              }
              memoizedSnapshot = nextSnapshot;
              memoizedSelection = nextSelection;
              return nextSelection;
            }; // Assigning this to a constant so that Flow knows it can't change.

            // Assigning this to a constant so that Flow knows it can't change.
            var maybeGetServerSnapshot = getServerSnapshot === undefined ? null : getServerSnapshot;
            var getSnapshotWithSelector = function () {
              return memoizedSelector(getSnapshot());
            };
            var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? undefined : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            };
            return [getSnapshotWithSelector, getServerSnapshotWithSelector];
          }, [getSnapshot, getServerSnapshot, selector, isEqual]),
          getSelection = _useMemo[0],
          getServerSelection = _useMemo[1];
        var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
        useEffect(function () {
          inst.hasValue = true;
          inst.value = value;
        }, [value]);
        useDebugValue(value);
        return value;
      }
      withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector;
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return withSelector_development;
}
if (browser$1.env.NODE_ENV === 'production') {
  withSelector.exports = requireWithSelector_production_min();
} else {
  withSelector.exports = requireWithSelector_development();
}
var withSelectorExports = withSelector.exports;
var useSyncExternalStoreExports = /*@__PURE__*/getDefaultExportFromCjs(withSelectorExports);
const {
  useSyncExternalStoreWithSelector
} = useSyncExternalStoreExports;
function useStore$1(api) {
  let selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : api.getState;
  let equalityFn = arguments.length > 2 ? arguments[2] : undefined;
  const slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
  React.useDebugValue(slice);
  return slice;
}
const createImpl = createState => {
  if ((undefined && undefined.MODE) !== "production" && typeof createState !== "function") {
    console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore$1(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = createState => createState ? createImpl(createState) : createImpl;
const initialState = {
  currentScreen: 1,
  language: "",
  env: "",
  keytrade_login: "",
  error: false,
  challenge: "",
  serialNumber: ""
};
const useStore = create(set => ({
  // initial state
  ...initialState,
  // Setters
  setCurrentScreen: screenNumber => set({
    currentScreen: screenNumber
  }),
  setLanguage: lang => set({
    language: lang
  }),
  setEnv: environment => set({
    env: environment
  }),
  setSerialNumber: serialNumber => set({
    serialNumber: serialNumber
  }),
  setChallenge: challenge => set({
    challenge: challenge
  }),
  setKeytradeLogin: value => set({
    keytrade_login: value
  }),
  setError: value => set({
    error: value
  }),
  resetState: () => set(initialState)
}));
const API_URL_TEST = "https://www.test.w.keytradebank.be/node/backend/cldprxy/s/access-mgmt";
const API_URL_PROD = "https://www.keytradebank.be/node/backend/cldprxy/s/access-mgmt";
const USE_MOCK_API = () => useStore.getState().env === "mock";
const headers = {
  'Content-Type': 'application/json'
};
let currentApiBaseUrl;
if (typeof window !== "undefined") {
  const hostname = window.location.hostname;
  if (hostname === "www.test.w.keytradebank.be") {
    currentApiBaseUrl = API_URL_TEST;
  } else if (hostname === "www.keytradebank.be") {
    currentApiBaseUrl = API_URL_PROD;
  } else {
    currentApiBaseUrl = useStore.getState().env !== 'prod' ? API_URL_TEST : API_URL_PROD;
  }
} else {
  // Fallback (SSR RENDERING)
  currentApiBaseUrl = useStore.getState().env !== 'prod' ? API_URL_TEST : API_URL_PROD;
}

// Mocked responses
const MOCK_RESPONSES = {
  addAccessMethod: {
    success: true,
    message: "",
    errorMessage: ""
  },
  activateHardkeyChallenge: {
    errorMessage: "",
    success: true
  },
  getHardkeyChallenge: {
    errorMessage: "",
    success: true,
    challenge: "963741852"
  }
};
async function fetchWrapper(url, params) {
  const response = await fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(params)
  });
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
}
const activateHardkeyChallenge = async params => {
  if (USE_MOCK_API()) {
    return MOCK_RESPONSES.activateHardkeyChallenge;
  }
  return fetchWrapper(`${currentApiBaseUrl}/activation/activateHardkeyChallenge`, params);
};
const getHardkeyChallenge = async params => {
  if (USE_MOCK_API()) {
    return MOCK_RESPONSES.getHardkeyChallenge;
  }
  return fetchWrapper(`${currentApiBaseUrl}/activation/getHardkeyChallenge`, params);
};
const StyledCard = props => {
  return /*#__PURE__*/React.createElement(componentsCard.Card, {
    fillContainer: true
  }, props.children);
};
const CenteredColumnDiv = styled.div`
    display: flex;
    flex-direction: column;
`;
const SpaceOnTop$1 = styled.div`
    padding-top: 2rem;
`;
const ContinueButton = props => {
  return /*#__PURE__*/React.createElement(SpaceOnTop$1, null, /*#__PURE__*/React.createElement(componentsButton.Button, props, props.children));
};
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
const SpaceOnTop = styled.div`
    margin-top: 2rem;
`;
const StyledInputText = props => {
  return /*#__PURE__*/React.createElement(SpaceOnTop, null, /*#__PURE__*/React.createElement(componentsInputtext.InputText, _extends({
    label: props.label,
    placeholder: props.placeholder,
    onChange: props.onChange,
    value: props.value,
    error: props.error
  }, props)));
};
const CenteredTextDiv = styled.div`
    text-align: center;
`;
styled(componentsParagraph.Paragraph)`
    padding-top: 4rem;
`;
styled.div`
    text-align:center;
`;
const StyledParagraphLightGrey = props => {
  return /*#__PURE__*/React.createElement(CenteredTextDiv, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    size: "sm",
    color: "GreyBlue"
  }, props.children));
};
const StyledParagraphLightGreyUncentered = props => {
  return /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    size: "sm",
    color: "GreyBlue"
  }, props.children);
};
const StyledParagraphLightGreyUncenteredSubtitle = props => {
  return /*#__PURE__*/React.createElement(CenteredTextDiv, {
    style: {
      whiteSpace: 'pre-wrap'
    }
  }, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    size: "lg",
    color: "GreyBlue"
  }, props.children));
};
const StyledTitle = props => {
  return /*#__PURE__*/React.createElement(componentsTitle.Title, {
    level: "h2",
    size: "sm",
    center: true,
    margin: "2rem"
  }, props.children);
};
const StyledSubTitle = props => {
  return /*#__PURE__*/React.createElement(componentsTitle.Title, {
    level: "h2",
    size: "xs",
    margin: "2rem"
  }, props.children);
};
var bullet_1_success$2 = "Vous pouvez vous connecter avec votre Hardkey et exécuter vos ordres de bourse et transactions";
var button_label_success$2 = "Se connecter avec votre Hardkey";
var continue_home$2 = "Continuer";
var error_btm$2 = "Redémarrer";
var error_paragraph$2 = "Souhaitez-vous réessayer ?";
var error_title$2 = "Oups ! Quelque chose s'est mal passé.";
var header_success$2 = "Parfait, vous venez de réactiver un nouveau Hardkey !";
var link_manual_activation$2 = "Activation manuelle";
var link_manual_activation_href$2 = "https://example.com/manual-activation";
var login_subtitle_pin$2 = "Si vous avez déjà modifié le code PIN de votre Hardkey, passez à l'étape suivante en cliquant sur le bouton « Continuer ». \nSi vous n'avez jamais modifié le code PIN de votre Hardkey, vous devez d'abord personnaliser votre code PIN à l'aide du code PIN initial que vous avez reçu par courrier et en suivant les étapes décrites ci-dessous.";
var login_title_challenge$2 = "Associez votre Hardkey à votre compte";
var login_title_pin$2 = "Créez votre propre code PIN";
var login_title_serial$2 = "Sélectionnez votre méthode de connexion : Hardkey";
var paragraph_1_success$2 = "À savoir";
var paragraph_2_success$2 = "Nous vous recommandons d'activer un Softkey sur un appareil supplémentaire (smartphone ou tablette). Vous pouvez en activer autant que vous le souhaitez.";
var paragraph_3_success$2 = "Vous pourrez toujours ajouter un appareil supplémentaire via Préférences > Sécurité > Authentification > Demander un nouveau Softkey.";
var serial_label$2 = "Numéro de série";
var serial_label_home$2 = "Numéro de série";
var serial_placeholder$2 = "_ _ - _ _ _ _ _ _ _ - _";
var subtitle$2 = "Activer";
var subtitle_challenge$2 = "DÉFI.";
var subtitle_challenge_home$2 = "DÉFI.";
var subtitle_home$2 = "Activez votre méthode de connexion";
var subtitle_pin$2 = "CODE PIN.";
var subtitle_pin_home$2 = "CODE PIN.";
var subtitle_serial$2 = "Le numéro de série se trouve au dos de votre Hardkey et contient 10 caractères";
var subtitle_serial_home$2 = "Le numéro de série se trouve au dos de votre Hardkey et contient 10 caractères";
var subtitle_success$2 = "À partir de maintenant...";
var title$2 = "Entrez le numéro de série de votre Hardkey";
var title_home$2 = "Votre première connexion";
var title_success$2 = "Activation du Hardkey";
var username_label$2 = "Numéro de client (vous l'avez reçu par courrier)";
var username_label_home$2 = "Numéro de client (vous l'avez reçu par courrier)";
var username_placeholder$2 = "KEYT";
var username_placeholder_home$2 = "KEYT";
var fr = {
  bullet_1_success: bullet_1_success$2,
  button_label_success: button_label_success$2,
  continue_home: continue_home$2,
  error_btm: error_btm$2,
  error_paragraph: error_paragraph$2,
  error_title: error_title$2,
  "form.action.challenge.label": "Signer",
  "form.action.label": "Soumettre",
  "form.fields.challenge.label": "Code de réponse",
  "form.fields.challenge.placeholder": "Entrez votre code de réponse",
  "form.fields.code.label": "Code",
  "form.fields.code.placeholder": "Entrez votre code",
  header_success: header_success$2,
  "instructions.0": "Prenez votre Hardkey et appuyez sur",
  "instructions.0.1": "pour l'allumer",
  "instructions.1": "Appuyez sur",
  "instructions.1.1": "et appuyez sur",
  "instructions.2": "Entrez le code PIN initial que vous avez reçu par courrier et confirmez en appuyant sur",
  "instructions.3": "Entrez votre nouveau code PIN personnel à 4 chiffres et appuyez sur",
  "instructions.4": "Saisissez-le à nouveau pour confirmer et appuyez sur",
  "instructions.6": "Cliquez sur le bouton OK pour terminer.",
  "instructions.7": "Entrez votre code de signature :",
  "instructions.challenge.0": "Allumez votre Hardkey",
  "instructions.challenge.0.1": "pour l'allumer",
  "instructions.challenge.1": "Appuyez sur",
  "instructions.challenge.1.1": "pour accéder au menu 4.Signatures",
  "instructions.challenge.2": "Entrez votre code PIN personnel (si demandé) et appuyez sur",
  "instructions.challenge.3": "Entrez",
  "instructions.challenge.3.1": "et appuyez sur",
  "instructions.challenge.4": "Vous voyez maintenant [Valeur 2], appuyez sur",
  "instructions.challenge.5": "Entrez le code affiché sur votre Hardkey",
  "instructions.challenge.changepin": "Créer un PIN",
  "instructions.changepin": "Continuer",
  link_manual_activation: link_manual_activation$2,
  link_manual_activation_href: link_manual_activation_href$2,
  login_subtitle_pin: login_subtitle_pin$2,
  login_title_challenge: login_title_challenge$2,
  login_title_pin: login_title_pin$2,
  login_title_serial: login_title_serial$2,
  paragraph_1_success: paragraph_1_success$2,
  paragraph_2_success: paragraph_2_success$2,
  paragraph_3_success: paragraph_3_success$2,
  serial_label: serial_label$2,
  serial_label_home: serial_label_home$2,
  serial_placeholder: serial_placeholder$2,
  subtitle: subtitle$2,
  subtitle_challenge: subtitle_challenge$2,
  subtitle_challenge_home: subtitle_challenge_home$2,
  subtitle_home: subtitle_home$2,
  subtitle_pin: subtitle_pin$2,
  subtitle_pin_home: subtitle_pin_home$2,
  subtitle_serial: subtitle_serial$2,
  subtitle_serial_home: subtitle_serial_home$2,
  subtitle_success: subtitle_success$2,
  title: title$2,
  title_home: title_home$2,
  title_success: title_success$2,
  username_label: username_label$2,
  username_label_home: username_label_home$2,
  username_placeholder: username_placeholder$2,
  username_placeholder_home: username_placeholder_home$2
};
var bullet_1_success$1 = "You can log in with your Hardkey and execute your stock market orders and transactions";
var button_label_success$1 = "Log in with your Hardkey";
var continue_home$1 = "Continue";
var error_btm$1 = "Restart";
var error_paragraph$1 = "Would you like to try again?";
var error_title$1 = "Oops! Something went wrong.";
var header_success$1 = "Perfect, you just reactivated a new Hardkey!";
var link_manual_activation$1 = "Manual activation";
var link_manual_activation_href$1 = "https://example.com/manual-activation";
var login_subtitle_pin$1 = "If you have already changed the PIN code of your Hardkey, please proceed to the next step by clicking on the \"Continue\" button.\nIf you have never changed your Hardkeys' PIN code, you need first to personalize your PIN code using the initial PIN code you received by mail and following the steps described hereunder.";
var login_title_challenge$1 = "Associate your hardkey with your account";
var login_title_pin$1 = "Create your own PIN";
var login_title_serial$1 = "Select your log in method: Hardkey";
var paragraph_1_success$1 = "Important to know";
var paragraph_2_success$1 = "We recommend that you activate a Softkey on an additional device (smartphone or tablet). You can activate as many as you want.";
var paragraph_3_success$1 = "You will always be able to add an extra device via Preferences > Security > Authentication > Request a new Softkey.";
var serial_label$1 = "Serial Number";
var serial_label_home$1 = "Serial Number";
var serial_placeholder$1 = "_ _ - _ _ _ _ _ _ _ - _";
var subtitle$1 = "Enable ";
var subtitle_challenge$1 = "CHALLENGE.";
var subtitle_challenge_home$1 = "CHALLENGE.";
var subtitle_home$1 = "Enable your sign-in method ";
var subtitle_pin$1 = "PIN CODE.";
var subtitle_pin_home$1 = "PIN CODE.";
var subtitle_serial$1 = "The serial number can be found on the back of your hardkey and contains 10 characters";
var subtitle_serial_home$1 = "The serial number can be found on the back of your hardkey and contains 10 characters";
var subtitle_success$1 = "From now on...";
var title$1 = "Enter the serial number of your Hardkey";
var title_home$1 = "Your first connection";
var title_success$1 = "Hardkey Activation";
var username_label$1 = "Client number (you've received it by mail)";
var username_label_home$1 = "Client number (you've received it by mail)";
var username_placeholder$1 = "KEYT";
var username_placeholder_home$1 = "KEYT";
var en = {
  bullet_1_success: bullet_1_success$1,
  button_label_success: button_label_success$1,
  continue_home: continue_home$1,
  error_btm: error_btm$1,
  error_paragraph: error_paragraph$1,
  error_title: error_title$1,
  "form.action.challenge.label": "Sign",
  "form.action.label": "Submit",
  "form.fields.challenge.label": "Response code",
  "form.fields.challenge.placeholder": "Enter your response code",
  "form.fields.code.label": "Code",
  "form.fields.code.placeholder": "Enter your code",
  header_success: header_success$1,
  "instructions.0": "Grab your hardkey and press",
  "instructions.0.1": "to turn it on ",
  "instructions.1": "Press",
  "instructions.1.1": "and press",
  "instructions.2": "Enter the initial PIN code you received by mail and confirm by pressing",
  "instructions.3": "Enter your new personal 4 digit PIN code and press",
  "instructions.4": "Enter it again to confirm and press",
  "instructions.6": "Click the OK button to finish.",
  "instructions.7": "Enter your signature code:",
  "instructions.challenge.0": "Turn on your hardkey",
  "instructions.challenge.0.1": "to turn it on ",
  "instructions.challenge.1": "Press",
  "instructions.challenge.1.1": "to reach menu 4.Signatures",
  "instructions.challenge.2": "Enter your personal PIN (if prompted) and press",
  "instructions.challenge.3": "Enter",
  "instructions.challenge.3.1": "and press",
  "instructions.challenge.4": "You now see [Value 2], press",
  "instructions.challenge.5": "Enter the code displayed on your hardkey",
  "instructions.challenge.changepin": "Create PIN",
  "instructions.changepin": "Continue",
  link_manual_activation: link_manual_activation$1,
  link_manual_activation_href: link_manual_activation_href$1,
  login_subtitle_pin: login_subtitle_pin$1,
  login_title_challenge: login_title_challenge$1,
  login_title_pin: login_title_pin$1,
  login_title_serial: login_title_serial$1,
  paragraph_1_success: paragraph_1_success$1,
  paragraph_2_success: paragraph_2_success$1,
  paragraph_3_success: paragraph_3_success$1,
  serial_label: serial_label$1,
  serial_label_home: serial_label_home$1,
  serial_placeholder: serial_placeholder$1,
  subtitle: subtitle$1,
  subtitle_challenge: subtitle_challenge$1,
  subtitle_challenge_home: subtitle_challenge_home$1,
  subtitle_home: subtitle_home$1,
  subtitle_pin: subtitle_pin$1,
  subtitle_pin_home: subtitle_pin_home$1,
  subtitle_serial: subtitle_serial$1,
  subtitle_serial_home: subtitle_serial_home$1,
  subtitle_success: subtitle_success$1,
  title: title$1,
  title_home: title_home$1,
  title_success: title_success$1,
  username_label: username_label$1,
  username_label_home: username_label_home$1,
  username_placeholder: username_placeholder$1,
  username_placeholder_home: username_placeholder_home$1
};
var bullet_1_success = "Kunt u inloggen met uw Hardkey en uw beursorders en transacties uitvoeren";
var button_label_success = "Inloggen met uw Hardkey";
var continue_home = "Doorgaan";
var error_btm = "Herstarten";
var error_paragraph = "Wilt u het opnieuw proberen?";
var error_title = "Oeps! Er is iets misgegaan.";
var header_success = "Perfect, u heeft zojuist een nieuwe Hardkey geheractiveerd!";
var link_manual_activation = "Handmatige activering";
var link_manual_activation_href = "https://example.com/manual-activation";
var login_subtitle_pin = "Als u de pincode van uw Hardkey al hebt gewijzigd, ga dan naar de volgende stap door op de knop \"Doorgaan\" te klikken. \nAls u de pincode van uw Hardkey nog nooit hebt gewijzigd, moet u eerst uw pincode personaliseren met de oorspronkelijke pincode die u per post hebt ontvangen. Volg hiervoor de onderstaande stappen.";
var login_title_challenge = "Koppel uw Hardkey aan uw account";
var login_title_pin = "Maak uw eigen PIN-code aan";
var login_title_serial = "Selecteer uw aanmeldmethode: Hardkey";
var paragraph_1_success = "Belangrijk om te weten";
var paragraph_2_success = "Wij raden u aan een Softkey te activeren op een extra apparaat (smartphone of tablet). U kunt er zoveel activeren als u wilt.";
var paragraph_3_success = "U kunt altijd een extra apparaat toevoegen via Voorkeuren > Beveiliging > Authenticatie > Vraag een nieuwe Softkey aan.";
var serial_label = "Serienummer";
var serial_label_home = "Serienummer";
var serial_placeholder = "_ _ - _ _ _ _ _ _ _ - _";
var subtitle = "Activeren";
var subtitle_challenge = "UITDAGING.";
var subtitle_challenge_home = "UITDAGING.";
var subtitle_home = "Activeer uw aanmeldmethode";
var subtitle_pin = "PINCODE.";
var subtitle_pin_home = "PINCODE.";
var subtitle_serial = "Het serienummer staat op de achterkant van uw Hardkey en bevat 10 tekens";
var subtitle_serial_home = "Het serienummer staat op de achterkant van uw Hardkey en bevat 10 tekens";
var subtitle_success = "Vanaf nu...";
var title = "Voer het serienummer van uw Hardkey in";
var title_home = "Uw eerste verbinding";
var title_success = "Hardkey Activering";
var username_label = "Klantnummer (u heeft dit per post ontvangen)";
var username_label_home = "Klantnummer (u heeft dit per post ontvangen)";
var username_placeholder = "KEYT";
var username_placeholder_home = "KEYT";
var nl = {
  bullet_1_success: bullet_1_success,
  button_label_success: button_label_success,
  continue_home: continue_home,
  error_btm: error_btm,
  error_paragraph: error_paragraph,
  error_title: error_title,
  "form.action.challenge.label": "Ondertekenen",
  "form.action.label": "Verzenden",
  "form.fields.challenge.label": "Antwoordcode",
  "form.fields.challenge.placeholder": "Voer uw antwoordcode in",
  "form.fields.code.label": "Code",
  "form.fields.code.placeholder": "Voer uw code in",
  header_success: header_success,
  "instructions.0": "Pak uw Hardkey en druk op",
  "instructions.0.1": "om hem aan te zetten",
  "instructions.1": "Druk op",
  "instructions.1.1": "en druk op",
  "instructions.2": "Voer de initiële PIN-code in die u per post heeft ontvangen en bevestig door op te drukken",
  "instructions.3": "Voer uw nieuwe persoonlijke 4-cijferige PIN-code in en druk op",
  "instructions.4": "Voer deze opnieuw in ter bevestiging en druk op",
  "instructions.6": "Klik op de OK-knop om te voltooien.",
  "instructions.7": "Voer uw handtekeningcode in:",
  "instructions.challenge.0": "Zet uw Hardkey aan",
  "instructions.challenge.0.1": "om hem aan te zetten",
  "instructions.challenge.1": "Druk op",
  "instructions.challenge.1.1": "om menu 4.Handtekeningen te bereiken",
  "instructions.challenge.2": "Voer uw persoonlijke PIN in (indien gevraagd) en druk op",
  "instructions.challenge.3": "Voer in",
  "instructions.challenge.3.1": "en druk op",
  "instructions.challenge.4": "U ziet nu [Waarde 2], druk op",
  "instructions.challenge.5": "Voer de code in die op uw Hardkey wordt weergegeven",
  "instructions.challenge.changepin": "PIN aanmaken",
  "instructions.changepin": "Doorgaan",
  link_manual_activation: link_manual_activation,
  link_manual_activation_href: link_manual_activation_href,
  login_subtitle_pin: login_subtitle_pin,
  login_title_challenge: login_title_challenge,
  login_title_pin: login_title_pin,
  login_title_serial: login_title_serial,
  paragraph_1_success: paragraph_1_success,
  paragraph_2_success: paragraph_2_success,
  paragraph_3_success: paragraph_3_success,
  serial_label: serial_label,
  serial_label_home: serial_label_home,
  serial_placeholder: serial_placeholder,
  subtitle: subtitle,
  subtitle_challenge: subtitle_challenge,
  subtitle_challenge_home: subtitle_challenge_home,
  subtitle_home: subtitle_home,
  subtitle_pin: subtitle_pin,
  subtitle_pin_home: subtitle_pin_home,
  subtitle_serial: subtitle_serial,
  subtitle_serial_home: subtitle_serial_home,
  subtitle_success: subtitle_success,
  title: title,
  title_home: title_home,
  title_success: title_success,
  username_label: username_label,
  username_label_home: username_label_home,
  username_placeholder: username_placeholder,
  username_placeholder_home: username_placeholder_home
};
var locales = {
  'fr': fr,
  'nl': nl,
  'en': en
};
const FailScreen = () => {
  const setCurrentScreen = useStore(state => state.setCurrentScreen);
  const setKeytradeLogin = useStore(state => state.setKeytradeLogin);
  const setError = useStore(state => state.setError);
  const {
    language
  } = useStore();
  const labels = locales[language];
  const handleRestart = () => {
    setKeytradeLogin('');
    setCurrentScreen(1);
    setError('');
  };
  return /*#__PURE__*/React.createElement("div", {
    style: styles.container
  }, /*#__PURE__*/React.createElement("h2", null, labels.error_title), /*#__PURE__*/React.createElement("p", null, labels.error_paragraph), /*#__PURE__*/React.createElement("button", {
    onClick: handleRestart,
    style: styles.restartButton
  }, labels.error_btn));
};
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh'
  },
  restartButton: {
    marginTop: '20px',
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: '#007BFF',
    color: '#FFF',
    borderRadius: '4px',
    boxShadow: '0px 0px 5px rgba(0,0,0,0.1)',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#0056b3'
    }
  }
};
const Screen1 = () => {
  const [inputValue, setInputValue] = React.useState("");
  const {
    setCurrentScreen,
    setKeytradeLogin,
    language,
    error,
    setError
  } = useStore();
  const labels = locales[language];
  const handleInputChange = event => {
    setInputValue(event.target.value);
  };
  const handleSubmit = async () => {
    setKeytradeLogin(inputValue);
    if (inputValue.length > 2) {
      setCurrentScreen(2);
    }
  };
  if (error) {
    return /*#__PURE__*/React.createElement(FailScreen, {
      error: error
    });
  }

  // change the strings to english 
  return /*#__PURE__*/React.createElement(CenteredColumnDiv, null, /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: "2rem"
    }
  }, /*#__PURE__*/React.createElement(StyledTitle, null, " ", labels.title_home, " "), /*#__PURE__*/React.createElement(StyledParagraphLightGrey, null, " ", labels.subtitle_home, " "), /*#__PURE__*/React.createElement(StyledInputText, {
    label: labels.username_label_home,
    labelWeight: "semiBold",
    placeholder: labels.username_placeholder_home,
    value: inputValue,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement(ContinueButton, {
    fullWidth: true,
    onClick: handleSubmit
  }, labels.continue_home))));
};
const HardKeyNumber = styled.div`
  display: inline-block;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 1.2rem;
  color: #fff;
  text-align: center;
  line-height: 2.4rem;
  background-color: #333E47;
`;
const HardKeyNumberGreen = styled.div`
  display: inline-block;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 1.2rem;
  color: #fff;
  text-align: center;
  line-height: 2.4rem;
  background-color: #41BA84;
`;
styled.div`
  display: inline-block;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 1.2rem;
  color: #fff;
  text-align: center;
  line-height: 2.4rem;
  background-color: #BF342B;
`;
styled.div`
    position: relative;
    min-width: 480px;
    max-width: 480px;
    width: 480px;
    margin: 0 auto;
`;
const LoginTitle = styled(componentsTitle.Title)`
    margin-bottom: 12px !important;
`;
const BackArrow = styled(componentsIcon.Icon)`
    cursor: pointer;
    position: absolute;
    top: 20px;
    left: 0;
    height: 24px !important;
    width: 24px !important;
`;
styled.div`
    width: 100%;
    border: 1px solid #E4EBEF;
    border-radius: 24px;
    margin-bottom: 24px;
    min-height: 250px;
    -webkit-box-shadow: 10px 10px 11px -6px rgba(184,184,184,0.5);
    -moz-box-shadow: 10px 10px 11px -6px rgba(184,184,184,0.5);
    box-shadow: 10px 10px 11px -6px rgba(184,184,184,0.5);
`;

// export const ChoiceLine = styled.div<{border}>`
//     position: relative;
//     padding: 58px;
//     cursor: pointer;
//     ${(props) => props.border ? 'border-bottom: 1px solid #E4EBEF;' : ''}
// `

styled.div`
    position: absolute;
    top: 32px;
    left: 32px;
    width: 52px;
    height: 52px;
`;
const FlexContainer = styled.div`
display: flex;
justify-content: space-between;
margin: 2rem;
`;
const MainSection = styled(FlexContainer)`
  flex: 80%;
`;
const Sidebar = styled(FlexContainer)`
  flex: 20%;
`;
styled(componentsParagraph.Paragraph)`
    position: absolute;
    top: 34px;
    left: 105px;
    height: 28px;
    line-height: 28px;
    font-size: 18px;
    font-weight: 600;
`;
styled(componentsParagraph.Paragraph)`
    position: absolute;
    top: 62px;
    left: 105px;
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    font-weight: 400;
`;
styled.div`
    position: absolute;
    top: 40px;
    right: 32px;
    width: 36px;
    height: 36px;
`;
styled(componentsIcon.Icon)`
    width: 36px !important;
    height: 36px !important;
`;
styled.div`
    cursor: pointer;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    width: 100%;
    margin-bottom: 12px;
`;
styled(componentsIcon.Icon)`
    width: 24px !important;
    height: 24px !important;
    position: absolute !important;
`;
const AccountIcon = styled(componentsIcon.Icon)`
    height: 14px !important;
    width: 14px !important;
    position: absolute;
    top: 0px;
    right: -1px;
`;
const CrossIcon = styled(componentsIcon.Icon)`
    cursor: pointer;
    height: 14px !important;
    width: 14px !important;
    position: relative;
    top: 2px;
    margin-top: 3px;
`;
const IconCircle = styled.div`
    position: relative;
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 1px solid #5e6467;
    border-radius: 7px;
    margin-top: 3px;
    top: 2px;
    margin-right: ;
`;
const KEYTBlock = styled.div`
    position: relative;
    margin: 0 auto;
    height: 32px;
    width: fit-content;
    border: 1.5px solid #CEDAE0;
    padding: 4.5px 12px;
    border-radius: 20px;
    margin-bottom: 30px;
`;
const KEYTLine = styled.div`
    display: inline-block;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 600;
    margin-left: 12px;
    margin-right:12px;
`;
styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 60px;
    background-color: #F2F5F7;
    border-radius: 24px;
    margin-bottom: 24px;    
`;
styled.span`
    margin-left: 8px;
`;
var img = "data:image/png;base64,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";
const SecondScreen$1 = () => {
  const {
    keytrade_login,
    setCurrentScreen,
    language,
    error,
    setError,
    setChallenge,
    serialNumber
  } = useStore();
  const labels = locales[language];
  const handleSubmit = async () => {
    try {
      const response = await getHardkeyChallenge({
        keytrade_login,
        serial_number: serialNumber.replace(/\D/g, '')
      });
      if (response.success) {
        setCurrentScreen(4);
        setChallenge(response.challenge);
      } else {
        throw new Error(response.errorMessage || 'Activation failed.');
      }
    } catch (err) {
      setError(err.message);
    }
  };
  const t = labelIdentifier => labels[labelIdentifier];
  if (error) {
    return /*#__PURE__*/React.createElement(FailScreen, {
      error: error
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      setCurrentScreen(2);
    }
  }, /*#__PURE__*/React.createElement(BackArrow, {
    icon: "icn_longArrowLeft"
  })), /*#__PURE__*/React.createElement(LoginTitle, {
    level: "h4",
    center: true
  }, labels.login_title_pin), /*#__PURE__*/React.createElement(StyledParagraphLightGreyUncenteredSubtitle, null, labels.login_subtitle_pin), /*#__PURE__*/React.createElement(CenteredColumnDiv, null, /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement(FlexContainer, null, /*#__PURE__*/React.createElement(MainSection, null, /*#__PURE__*/React.createElement(componentsList.Stepper, {
    hideLastCounter: true,
    margin: "4rem 0 0"
  }, /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.0`)} `, " ", /*#__PURE__*/React.createElement(componentsIcon.Icon, {
    icon: "icn_hardKeyOk",
    margin: "0 0 -0.8rem"
  }), " ", `${t(`instructions.0.1`)} `)), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.1`)} `, " ", /*#__PURE__*/React.createElement(HardKeyNumber, null, "5"), " ", `${t(`instructions.1.1`)} `, " ", /*#__PURE__*/React.createElement(HardKeyNumber, null, "1"))), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.2`)} `, " ", /*#__PURE__*/React.createElement(componentsIcon.Icon, {
    icon: "icn_hardKeyOk",
    margin: "0 0 -0.8rem"
  }))), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.3`)} `, " ", /*#__PURE__*/React.createElement(componentsIcon.Icon, {
    icon: "icn_hardKeyOk",
    margin: "0 0 -0.8rem"
  }))), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.4`)}`, " ", /*#__PURE__*/React.createElement(componentsIcon.Icon, {
    icon: "icn_hardKeyOk",
    margin: "0 0 -0.8rem"
  }))), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsButton.Button, {
    margin: "2rem 0 0",
    fullWidth: true,
    size: "lg",
    onClick: handleSubmit
  }, t('instructions.changepin'))))), /*#__PURE__*/React.createElement(Sidebar, null, /*#__PURE__*/React.createElement("div", {
    style: {
      borderRadius: '100%',
      border: '1px solid #E4EBEF',
      height: '100px',
      width: '100px',
      padding: '30px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: img,
    width: 100,
    height: 100
  })))))));
};
const SecondScreen = () => {
  const [code, setCode] = React.useState('');
  const {
    keytrade_login,
    setCurrentScreen,
    language,
    error,
    setError,
    challenge,
    serialNumber
  } = useStore();
  const labels = locales[language];
  function signatureCodeHandler(e) {
    setCode(e.target.value);
  }
  const handleSubmit = async () => {
    if (code.length !== 9) {
      setError(true);
    } else {
      const serial_number = serialNumber.replace(/\D/g, '');
      const signature = code.replace(/\D/g, '');
      try {
        const response = await activateHardkeyChallenge({
          keytrade_login,
          serial_number,
          signature
        });
        if (response.success) {
          setCurrentScreen(5);
        } else {
          throw new Error(response.errorMessage || 'Activation failed.');
        }
      } catch (err) {
        setError(err.message);
      }
    }
  };
  if (error) {
    return /*#__PURE__*/React.createElement(FailScreen, {
      error: error
    });
  }
  const t = labelIdentifier => labels[labelIdentifier];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      setCurrentScreen(3);
    }
  }, /*#__PURE__*/React.createElement(BackArrow, {
    icon: "icn_longArrowLeft"
  })), /*#__PURE__*/React.createElement(LoginTitle, {
    level: "h4",
    center: true
  }, labels.login_title_challenge), /*#__PURE__*/React.createElement(CenteredColumnDiv, null, /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement(FlexContainer, null, /*#__PURE__*/React.createElement(MainSection, null, /*#__PURE__*/React.createElement(componentsList.Stepper, {
    hideLastCounter: true,
    margin: "4rem 0 0"
  }, /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.challenge.0`)} `)), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.challenge.1`)} `, " ", /*#__PURE__*/React.createElement(HardKeyNumber, null, "4"), " ", `${t(`instructions.challenge.1.1`)} `)), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.challenge.2`)} `, " ", /*#__PURE__*/React.createElement(HardKeyNumberGreen, null, "OK"))), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.challenge.3`)} `, " ", challenge, " ", `${t(`instructions.challenge.3.1`)} `, /*#__PURE__*/React.createElement(HardKeyNumberGreen, null, "OK"))), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.challenge.4`)}`, " ", /*#__PURE__*/React.createElement(HardKeyNumberGreen, null, "OK"))), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, `${t(`instructions.challenge.5`)}`)), /*#__PURE__*/React.createElement(componentsList.Step, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "semiBold"
  }, t('form.fields.challenge.label')), /*#__PURE__*/React.createElement(componentsInputtext.InputText, {
    name: "code",
    id: "code",
    placeholder: t('form.fields.challenge.placeholder'),
    inputmode: "numeric",
    label: t('form.fields.challenge.label'),
    hideLabel: true,
    margin: "2rem 0 0",
    value: code,
    mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
    guide: false,
    onChange: signatureCodeHandler
  })), /*#__PURE__*/React.createElement(componentsList.Step, null))), /*#__PURE__*/React.createElement(Sidebar, null, /*#__PURE__*/React.createElement("div", {
    style: {
      borderRadius: '100%',
      border: '1px solid #E4EBEF',
      height: '100px',
      width: '100px',
      padding: '30px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: img,
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement(componentsButton.Button, {
    margin: "2rem",
    size: "lg",
    onClick: handleSubmit
  }, t('form.action.challenge.label')))));
};
const HardKeySerial = () => {
  const [inputValue, setInputValue] = React.useState("");
  const {
    setCurrentScreen,
    language,
    error,
    setSerialNumber,
    keytrade_login
  } = useStore();
  const labels = locales[language];
  const handleInputChange = event => {
    setInputValue(event.target.value);
  };
  const handleSubmit = async () => {
    setSerialNumber(inputValue);
    if (inputValue.length === 12) {
      setCurrentScreen(3);
    }
  };
  if (error) {
    return /*#__PURE__*/React.createElement(FailScreen, {
      error: error
    });
  }

  // change the strings to english 
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      setCurrentScreen(1);
    }
  }, /*#__PURE__*/React.createElement(BackArrow, {
    icon: "icn_longArrowLeft"
  })), /*#__PURE__*/React.createElement(LoginTitle, {
    level: "h4",
    center: true
  }, labels.login_title_serial), /*#__PURE__*/React.createElement(KEYTBlock, null, /*#__PURE__*/React.createElement(IconCircle, null, /*#__PURE__*/React.createElement(AccountIcon, {
    icon: "icn_userRegular",
    color: "#5e6467"
  })), /*#__PURE__*/React.createElement(KEYTLine, null, keytrade_login), /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      setCurrentScreen(1);
    },
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    icon: "icn_cross",
    color: "#5e6467"
  }))), /*#__PURE__*/React.createElement(CenteredColumnDiv, null, /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: "2rem"
    }
  }, /*#__PURE__*/React.createElement(StyledTitle, null, " ", labels.title, " "), /*#__PURE__*/React.createElement(StyledInputText, {
    inputmode: "numeric",
    margin: "2rem 0 0",
    mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/],
    label: labels.serial_label,
    labelWeight: "semiBold",
    placeholder: labels.serial_placeholder,
    value: inputValue,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement(StyledParagraphLightGreyUncentered, null, " ", labels.subtitle_serial, " "), /*#__PURE__*/React.createElement(ContinueButton, {
    fullWidth: true,
    onClick: handleSubmit
  }, labels.continue_home)))));
};
const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: #E4E8E1;
    margin-top: 4rem;
    margin-bottom: 4rem;
`;
const CenteredDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
const FullWidth = styled.div`
    width: 100%;
`;
const StyledListDiv = styled.div`
background-color: #f1f5f7;
margin-top: -4rem;
margin-bottom: -4rem;
padding-top: 4rem;
padding-bottom: 4rem;
padding-right: 2rem;
li::before {content: counter(li); color: #00B3DB; padding-right: 2rem; padding-left: 2rem;
    display: inline-block; width: 1em;
    margin-left: -1em}
    li {counter-increment: li}
`;
const Success = () => {
  const {
    setCurrentScreen,
    keytrade_login,
    language,
    resetState
  } = useStore();
  const labels = locales[language];
  return /*#__PURE__*/React.createElement(CenteredColumnDiv, null, /*#__PURE__*/React.createElement(componentsCard.Card, {
    fillContainer: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CenteredDiv, null, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '2rem',
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      setCurrentScreen(1);
    }
  }, /*#__PURE__*/React.createElement(componentsIcon.Icon, {
    icon: "icn_arrowLeft"
  })), /*#__PURE__*/React.createElement(FullWidth, null, /*#__PURE__*/React.createElement(StyledTitle, null, labels.title_success)))), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(StyledSubTitle, null, labels.header_success), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '2rem'
    }
  }, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.subtitle_success), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: '2rem'
    }
  }, /*#__PURE__*/React.createElement(componentsList.List, {
    type: "iconList"
  }, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.bullet_1_success)))), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(StyledListDiv, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledSubTitle, null, labels.paragraph_1_success), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '2rem'
    }
  }, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.paragraph_2_success), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.paragraph_3_success)))), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      marginRight: "auto",
      marginLeft: 'auto',
      paddingBottom: '4rem',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(componentsButton.Button, {
    size: "lg",
    onClick: () => {
      if (typeof window !== 'undefined') {
        window.location.href = `https://www.keytradebank.com/${language}/`;
      }
    }
  }, labels.button_label_success)))));
};
const useLanguageFromUrl = function () {
  let defaultLang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
  const initialLang = React.useRef(defaultLang);
  const {
    setLanguage
  } = useStore();
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href);
      const pathParts = url.pathname.split('/');
      const languageValue = pathParts[1] ? pathParts[1] : initialLang.current;
      setLanguage(languageValue ?? defaultLang);
    }
  }, [defaultLang]);
};
const GlobalStyle = He`
  strong {
    font-weight: bold !important;
    font-size: inherit;
  }
`;
const SpinnerContainer = styled.div`
  margin: 150px auto;
  width: 100%;
  text-align: center;
`;
const HardkeyActivation = _ref => {
  let {
    labels,
    lang = 'en',
    env = "test"
  } = _ref;
  const [isLoading, setIsLoading] = React.useState(true);
  const {
    currentScreen,
    setLanguage,
    setEnv,
    error
  } = useStore(state => ({
    currentScreen: state.currentScreen,
    setLanguage: state.setLanguage,
    setEnv: state.setEnv,
    error: state.error
  }));
  useLanguageFromUrl();
  React.useEffect(() => {
    setIsLoading(true);
    env && setEnv(env);
    setIsLoading(false);
  }, [lang, env]);
  if (error) {
    return /*#__PURE__*/React.createElement(FailScreen, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(componentsLoader.LoaderSpinner, null), /*#__PURE__*/React.createElement("div", null)) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GlobalStyle, null), currentScreen === 1 && /*#__PURE__*/React.createElement(Screen1, null), currentScreen === 2 && /*#__PURE__*/React.createElement(HardKeySerial, null), currentScreen === 3 && /*#__PURE__*/React.createElement(SecondScreen$1, null), currentScreen === 4 && /*#__PURE__*/React.createElement(SecondScreen, null), currentScreen === 5 && /*#__PURE__*/React.createElement(Success, null)));
};
module.exports = HardkeyActivation;